module.exports = __webpack_public_path__ + "static/media/bringthepaint.7f3acacc.jpg";